import React from "react";
import arrowIcon from "@assets/images/Frame-9.svg";

type ButtonProps = {
  title: string;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ title, className = "", ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      className={`px-3 md:px-4 py-2.5 md:py-[17.5px] text-xs md:text-lg rounded-full flex items-center gap-2.5 bg-[#080c2d] hover:bg-[#0f1554] text-white flex-shrink-0 transition-colors duration-300 group/btn ${className}`}
    >
      {title}

      <img
        src={arrowIcon}
        alt="arrow icon"
        className="transition-all duration-300 size-8 md:size-10 group-hover/btn:translate-x-1"
      />
    </button>
  );
};

export default Button;
